import React from 'react';
import * as classes from './divider.styles';

export const DividerComponent: React.FC = props => {
  return <span className={classes.root} />;
};
